import React, { useState, useCallback } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import exportingModule from "highcharts/modules/exporting";
import offlineExportingModule from "highcharts/modules/offline-exporting";
import ExportDataModule from "highcharts/modules/export-data";
import boostModule from "highcharts/modules/boost";
import "./HaqtChart.scss";
import { getSessionStorageItem } from "../../utils/sessionStorageUtils";
import { getCurrentDateTime } from "../../utils/CurrentDateTime";

exportingModule(Highcharts);
ExportDataModule(Highcharts);
offlineExportingModule(Highcharts);
boostModule(Highcharts);

const HaqtChart = (props) => {
  const [chartType] = useState(
    props.options?.chart?.defaultChartType || "line",
  );
  // const systemName = getSessionStorageItem("haqt-selected-system")?.system
  //   ?.name;
  // Dheeraj edit
  const systemName = getSessionStorageItem("wosh-selected-device");

  const openInFullIconSvg = `
    <svg width="800px" height="800px" viewBox="-4 -4 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M13 6h4.293L6 17.293V13H5v6h6v-1H6.707L18 6.707V11h1V5h-6v1z"/><path fill="none" d="M0 0h24v24H0z"/></svg>
    `;

  // Debounce function to limit the rate at which a function can fire
  const debounce = (func, wait) => {
    let timeout;
    return function (...args) {
      const context = this;
      clearTimeout(timeout); // Clear any existing timeout to reset the wait period
      timeout = setTimeout(() => func.apply(context, args), wait); // Set a new timeout
    };
  };

  // useCallback hook to memoize the debounced handleRedraw function
  const handleRedraw = useCallback(
    debounce(() => {
      // eslint-disable-next-line no-console
      console.timeEnd("redraw"); // Log the end time for the redraw event
    }, 300), // Wait period of 300ms
    [], // Dependency array, empty so the function is only created once
  );

  // const formatLocalDateTime = (timestamp) => {
  //   const date = new Date(timestamp);
  //   // const year = date.getFullYear();
  //   const monthNames = [
  //     "Jan",
  //     "Feb",
  //     "Mar",
  //     "Apr",
  //     "May",
  //     "Jun",
  //     "Jul",
  //     "Aug",
  //     "Sep",
  //     "Oct",
  //     "Nov",
  //     "Dec",
  //   ];
  //   const month = monthNames[date.getMonth()];
  //   const day = String(date.getDate()).padStart(2, "0");
  //   const hours = String(date.getHours()).padStart(2, "0");
  //   const minutes = String(date.getMinutes()).padStart(2, "0");
  //   // const seconds = String(date.getSeconds()).padStart(2, '0');

  //   return `${hours === 0 ? `${day} ${month}` : `${day} ${month}, ${hours}:${minutes}`}`;
  // };

  const formatLocalDateTime = (timestamp) => {
    // Dheeraj Edit -
    const date = new Date(timestamp);
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    // Calculate time range
    const firstPoint = props.series[0]?.data[0];
    const lastPoint = props.series[0]?.data[props.series[0]?.data?.length - 1];
    let timeRange;
    if (
      firstPoint &&
      lastPoint &&
      Array.isArray(firstPoint) &&
      Array.isArray(lastPoint)
    ) {
      const firstTime = new Date(firstPoint[0]).getTime();
      const lastTime = new Date(lastPoint[0]).getTime();
      timeRange = lastTime - firstTime;
    }

    const isWithin24Hours = timeRange && timeRange <= 24 * 60 * 60 * 1000;

    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const month = monthNames[date.getMonth()];

    // Static variable to track the last date we showed
    if (typeof formatLocalDateTime.lastShownDate === "undefined") {
      formatLocalDateTime.lastShownDate = null;
    }

    const currentDateStr = `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`;
    const shouldShowDate = currentDateStr !== formatLocalDateTime.lastShownDate;
    formatLocalDateTime.lastShownDate = currentDateStr;

    if (isWithin24Hours) {
      // For 24-hour view
      if (hours === "00" && minutes === "00") {
        return `${day} ${month}`; // Show date at midnight
      }
      return `${hours}:${minutes}`;
    } else {
      // For multi-day view
      if (shouldShowDate) {
        return `${day} ${month}`; // Show date only once per day
      }
      return `${hours}:${minutes}`;
    }
  };

  const options = {
    caption: {
      text: props.options?.caption?.text || "",
      align: props.options?.caption?.align || "center",
      margin: props.options?.caption?.margin || 15,
      verticalAlign: props.options?.caption?.verticalAlign || "bottom",
      x: props.options?.caption?.x || 0,
      y: props.options?.caption?.y || 0,
    },
    chart: {
      type: chartType,
      backgroundColor: props.options?.chart?.backgroundColor || "#fff",
      borderColor: props.options?.chart?.borderColor || "#334eff",
      borderRadius: props.options?.chart?.borderRadius || 0,
      borderWidth: props.options?.legend?.borderWidth || 0,
      className: "haqt-chart-container " + props.options?.chart?.className,
      height: props.options?.chart?.height || 0, //Defaults to container height or 400px if no height on the container
      zoomType: props.options?.chart?.zoomType || "undefined",
      resetZoomButton: {
        position: {
          x: 0,
          y: 0,
        },
      },
      events: {
        redraw: function () {
          // console.time('redraw');
          handleRedraw();
        },
      },
    },
    colors: [
      "#54909D",
      "#72D974",
      "#80EAE5", // three color are fixed
      "#F5A623",
      "#7ED321",
      "#4A90E2",
      "#D0021B",
      "#9B9B9B",
      "#50E3C2",
      "#BD10E0",
      "#FFC0CB",
      "#FF5733",
      "#33FF57",
      "#5733FF",
      "#FF5733",
      "#33FF57",
      "#5733FF",
      "#FF5733",
      "#33FF57",
      "#5733FF",
    ], //  remaning 17 needs to confirm ,according needs to change
    credits: {
      enabled: false,
    },
    boost: {
      enabled: true,
      useGPUTranslations: true,
      ...(props.options?.boost?.seriesThreshold && { seriesThreshold: 1 }),
    },
    title: {
      text: props.options?.title?.text || "",
      align: props.options?.title?.align || "center",
      margin: props.options?.title?.margin || 15,
    },
    subtitle: {
      useHTML: props.options?.subtitle?.useHTML,
      text: props.options?.subtitle?.text || "",
      align: props.options?.subtitle?.align || "center",
    },
    xAxis: {
      tickInterval: Math.ceil(props.series[0].data.length / 8), // Dheeraj Edit
      categories: props?.options?.xAxis?.categories,
      type: props.options?.xAxis?.type,
      gridLineWidth: 0,
      gridLineColor: "#54909D",
      gridLineDashStyle: "dot",
      // lineColor: '#fff',
      labels: {
        // rotation: -45, //Dheeraj Edit - Added overflow too
        overflow: "justify",
        ...(props.options?.xAxis?.type && {
          formatter: function () {
            return formatLocalDateTime(this.value);
          },
        }),
        // style: {
        //     color: '#fff'
        // }
      },
      lineColor: "#54909D",
      // tickColor: '#fff'
    },
    yAxis: {
      gridLineWidth: 0,
      min: 0,
      gridLineColor: "#54909D",
      gridLineDashStyle: "dot",

      title: {
        text: props.options?.yAxis?.title,
        // style: {
        //     color: '#fff'
        // }
      },
      // Dheeraj Edit - added
      allowDecimals: false, // This forces integer values
      labels: {
        // style: {
        //     color: '#fff'
        // }
      },
      lineColor: "#54909D",
      // tickColor: '#fff',
    },
    legend: {
      align: props.options?.legend?.align || "center",
      enabled: props.options?.legend?.enabled === false ? false : true,
      alignColumns: props.options?.legend?.alignColumns || true,
      backgroundColor: props.options?.legend?.backgroundColor || undefined,
      borderColor: props.options?.legend?.borderColor || "#999999",
      borderRadius: props.options?.legend?.borderRadius || 0,
      borderWidth: props.options?.legend?.borderWidth || 0,
      className: "highcharts-no-tooltip " + props.options?.legend?.className,
      layout: props.options?.legend?.layout || "horizontal",
      margin: props.options?.legend?.margin || 12,
      maxHeight: props.options?.legend?.maxHeight || undefined,
      padding: props.options?.legend?.padding || 8,
      title: {
        text: props.options?.legend?.title || "",
      },
      verticalAlign: props.options?.legend?.verticalAlign || "bottom",
      x: props.options?.legend?.x || 0,
      y: props.options?.legend?.y || 0,
    },
    tooltip: {
      backgroundColor: props.options?.tooltip?.backgroundColor || "#fff",
      borderColor: props.options?.tooltip?.borderColor || undefined,
      borderRadius:
        props.options?.tooltip?.borderRadius === 0
          ? 0
          : props.options?.tooltip?.borderRadius || 5,
      borderWidth: props.options?.tooltip?.borderWidth || undefined,
      className: "haqt-tooltip " + (props.options?.tooltip?.className || ""),
      enabled: props.options?.tooltip?.enabled === false ? false : true,
      formatter: props.options?.tooltip?.formatter || undefined,
      positioner: undefined,
      valuePrefix: props.options?.tooltip?.valuePrefix || undefined,
      valueSuffix: props.options?.tooltip?.valueSuffix || undefined,
      zIndex: 9999,
      style: {
        color: "#000",
        // fontWeight: 600,
        shadow: "0px 3px 6px #000000",
        pointerEvents: "auto",
      },
    },
    plotOptions: {
      series: {
        // enableMouseTracking: false //Enable for performance on charts with large data points.
        // color: '#54909D', //Will not work for stacking.
        // stacking: 'normal'
      },

      //area chart options
      area: {
        // colorByPoint: true,
        dataLabels: {
          enabled: false,
        },
        // fillColor: {
        //     linearGradient: {
        //         x1: 0,
        //         y1: 0,
        //         x2: 0,
        //         y2: 1
        //     },
        //     stops: [
        //         [0, '#54909D'],
        //         [1, Highcharts.color('#54909D').setOpacity(0.5).get('rgba')]
        //     ]
        // },
        fillOpacity: 0.5,
        marker: {
          radius: 2,
        },
        states: {
          hover: {
            lineWidth: 1,
          },
        },
      },
      bar: {
        allowPointSelect: true,
        borderRadius: 5,
        cursor: "pointer",
        dataLabels: {
          enabled: true,
          inside: true,
          align: "right",
          formatter: function () {
            return `${this.y.toFixed(2)}`; // Format y value as a string with two decimal places
          },
        },
        pointPadding: 0.2, // Increase point padding for thicker bars
        groupPadding: 0.1, // Increase group padding for more space between groups
        minPointLength: 5, // Minimum height for bars
        states: {
          select: {
            color: "#98EEB6",
            borderColor: "#98EEB6",
          },
        },
      },
      line: {
        allowPointSelect: true,
        // colorByPoint: true,
        // clip: true, // Should be true if chart.zoomType is set
        cursor: "pointer",
        dataLabels: {
          enabled: false,
        },
        marker: {
          radius: 2,
        },
        states: {
          hover: {
            lineWidth: 1,
          },
        },
      },
      column: {
        allowPointSelect: true,
        borderRadius: 5,
        // clip: true, // Should be true if chart.zoomType is set
        cursor: "pointer",
        dataLabels: {
          enabled: true,
          inside: false,
          align: "right",
          formatter: function () {
            return `${this.y.toFixed(0)}`; // Format y value as a string with two decimal places
          },
        },
        states: {
          select: {
            color: "#98EEB6",
            borderColor: "#98EEB6",
          },
        },
      },
      pie: {
        allowPointSelect: true,
        borderWidth: 1,
        borderRadius: 5,
        // clip: true, // Should be true if chart.zoomType is set
        // colors: haqtColors,
        colorAxis: {
          minColor: "#005572",
          maxColor: Highcharts.getOptions().colors[0],
        },
        cursor: "pointer",
        dataLabels: {
          enabled: true,
        },
        showInLegend: true,
        size: "75%",
      },
    },
    series: props?.series || [],
    // navigation: {
    //     buttonOptions: {
    //         theme: {
    //             style: {
    //                 fontSize: '20px',
    //                 color: '#888'
    //             },
    //             states: {
    //                 hover: {
    //                     style: {
    //                         color: '#000'
    //                     }
    //                 }
    //             }
    //         },
    //         useHTML: true
    //     }
    // },
    exporting: {
      sourceWidth: 850,
      sourceHeight: 450,
      buttons: {
        expandButton: {
          symbol: `url(data:image/svg+xml;base64,${btoa(openInFullIconSvg)})`,
          // _titleKey: 'expand',
          // x: -10,
          enabled: props.options?.expand?.enabled === true ? true : false,
          // onclick: (props.options?.expand?.onClick) !== undefined ? props.options?.expand?.onClick : null,
          //text: "Expand", //TODO: Remove after icon is working
          className: "expand-chart",
          onclick: () => {
            props.handleChartClick();
          },
        },
        contextButton: {
          enabled: props.options?.exporting?.enabled === false ? false : true,
          menuItems: [
            "viewFullscreen",
            "separator",
            "downloadJPEG",
            "downloadPDF",
            "downloadCSV",
            ...(props.options?.exporting?.isChartType
              ? [
                  "separator",
                  {
                    text: "Line Chart",
                    onclick: function () {
                      this.update({
                        chart: {
                          type: "line",
                        },
                      });
                    },
                  },
                  {
                    text: "Column Chart",
                    onclick: function () {
                      this.update({
                        chart: {
                          type: "column",
                        },
                      });
                    },
                  },
                  {
                    text: "Bar Chart",
                    onclick: function () {
                      this.update({
                        chart: {
                          type: "bar",
                        },
                      });
                    },
                  },
                  {
                    text: "Area Chart",
                    onclick: function () {
                      this.update({
                        chart: {
                          type: "area",
                        },
                      });
                    },
                  },
                ]
              : []),
          ],
        },
      },
      chartOptions: {
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true,
            },
          },
        },
      },
      // enabled: (props.options?.exporting?.enabled === false) ? false: true, //defaults to true,
      // error: console.log("Unexedpected error happened during exporting the chart"),
      filename: `${systemName}_${props.options?.exporting?.fileName || "MizuLink-Export"}_${getCurrentDateTime()}`,
    },
    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 500,
          },
          chartOptions: {
            legend: {
              align: "center",
              verticalAlign: "bottom",
              layout: props.options?.legend?.layout || "horizontal",
            },
          },
        },
      ],
    },
  };

  return (
    <HighchartsReact
      highcharts={Highcharts}
      options={options}
      containerProps={{
        className: "haqt-chart-container",
      }}
    />
  );
};

export default HaqtChart;
